import type { ReactNode } from 'react';
import { ToastProvider } from '@/shared/components/Toast';
import { AuthProvider } from './AuthProvider';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';

/**
 * Empilha os provedores da aplicacao.
 *
 * A ordem importa: `ThemeProvider` aplica o atributo no `<html>` antes de
 * qualquer componente renderizar; `ToastProvider` fica por fora para que o
 * `AuthProvider` possa avisar quando a sessao expira; e `AuthProvider` envolve o
 * `QueryProvider` porque um `401` numa consulta precisa encerrar a sessao.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <QueryProvider>{children}</QueryProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
